import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue'

/** Props：logo 可选，默认选中右侧“Thể thao”(索引 1) */

export default /*#__PURE__*/_defineComponent({
  name: 'HomeNav',
  props: {
    logo: { type: String, required: false },
    defaultActive: { type: Number, required: false },
    fadeDistance: { type: Number, required: false },
    homeTabs: { type: Array, required: false }
  },
  emits: ["update:activeIndex", "search", "click-left"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'update:activeIndex', index: 0 | 1): void
  (e: 'search'): void
  (e: 'click-left'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
  logo?: string
  defaultActive?: number
  fadeDistance?: number,  // 背景从 0 到 1 的滚动距离（像素），默认 80
  homeTabs?:any[]
}





const activeIndex = ref(props.defaultActive !== undefined ? props.defaultActive : 1);

const scrollY = ref(0)

const onSelect = (i: 0 | 1) => {
  if (activeIndex.value !== i) {
    activeIndex.value = i
    emit('update:activeIndex', i)
  }
}

const handleScroll = () => {
  scrollY.value = window.scrollY || document.documentElement.scrollTop || 0
}

watch(()=> props.defaultActive, (newVal) =>{
  activeIndex.value = newVal;
},{immediate:true});

onMounted(() => {
  handleScroll()
  window.addEventListener('scroll', handleScroll, { passive: true })
})
onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})

/** 背景透明度：随滚动线性增长 */
const fadeDist = computed(() => Math.max(1, props.fadeDistance ? props.fadeDistance: 80))
const bgAlpha = computed(() => {
  const a = scrollY.value / fadeDist.value
  return Math.max(0, Math.min(1, a))
})

const logo = computed(() => props.logo || '')
const buttonBg1 = require(`@/assets/vi/home_douji.png`);
const buttonBg2 = require(`@/assets/vi/home_sport.png`);
const searchIcon = require(`@/assets/vi/sousuo.png`);

const btnStyle = (i: 0 | 1) => {
  const icon = i === 0 ? buttonBg1 : buttonBg2
  const base = {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: '100% 100%',
    // padding: '0 16px 0 44px',
  } as Record<string,string>

  if (activeIndex.value === i) {
    // 两层背景：第一层是图标，第二层是橙色渐变
    base.backgroundImage = `url(${icon}), linear-gradient(180deg,${process.env.VUE_APP_MAINCOLOR} 0%,${process.env.VUE_APP_MAINCOLOR} 100%)`
    base.backgroundRepeat = 'no-repeat, no-repeat'
    base.backgroundPosition = 'center, center'
    base.backgroundSize = '100% 100%'
    base.color = '#fff'
  } else {
    base.backgroundImage = null;
    base.color = 'rgba(255,255,255,.85)'
    // 如果想有个浅底，也可加第三层：', rgba(0,0,0,.0)'
  }
  return base
}


const __returned__ = { props, emit, activeIndex, scrollY, onSelect, handleScroll, fadeDist, bgAlpha, logo, buttonBg1, buttonBg2, searchIcon, btnStyle }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})